<!-- titulo -->
<section class="flex mb-8">
  <div class="flex-1 flex flex-col">
    <span class="span1 text-neutral-600 text-2xl font-semibold font-['Inter'] leading-normal">
      Resumen de cobros
    </span>
    <span class="text-neutral-600 text-sm font-['Inter'] leading-tight">
      Estás visualizando toda la información disponible.
    </span>
  </div>
  <div class="flex gap-2 items-center">
    <div class="relative">
      <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <img class="w-6 h-6 text-gray-500" src="../../../assets/img/ic-search.svg" />
      </div>
      <input [formControl]="filterControl" type="text" placeholder="Buscar"
        class="h-[40px] w-[256px] bg-gray-50 border-2 border-stone-400 text-gray-900 text-sm rounded-lg block ps-10">
    </div>
    <button
      class="action-button h-[40px] flex items-center gap-1 bg-indigo-500 text-white px-4 rounded-lg shadow hover:bg-indigo-600"
      (click)="openNewChargeDialog()">
      <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 4C10.4178 4 8.87103 4.46919 7.55544 5.34824C6.23985 6.22729 5.21447 7.47672 4.60897 8.93853C4.00347 10.4003 3.84504 12.0089 4.15372 13.5607C4.4624 15.1126 5.22433 16.538 6.34315 17.6569C7.46197 18.7757 8.88743 19.5376 10.4393 19.8463C11.9911 20.155 13.5997 19.9965 15.0615 19.391C16.5233 18.7855 17.7727 17.7602 18.6518 16.4446C19.5308 15.129 20 13.5822 20 12C19.9977 9.87897 19.1541 7.84547 17.6543 6.34568C16.1545 4.84589 14.121 4.00229 12 4ZM14.6667 12.6667H12.6667V14.6667C12.6667 14.8435 12.5964 15.013 12.4714 15.1381C12.3464 15.2631 12.1768 15.3333 12 15.3333C11.8232 15.3333 11.6536 15.2631 11.5286 15.1381C11.4036 15.013 11.3333 14.8435 11.3333 14.6667V12.6667H9.33334C9.15652 12.6667 8.98696 12.5964 8.86193 12.4714C8.73691 12.3464 8.66667 12.1768 8.66667 12C8.66667 11.8232 8.73691 11.6536 8.86193 11.5286C8.98696 11.4036 9.15652 11.3333 9.33334 11.3333H11.3333V9.33333C11.3333 9.15652 11.4036 8.98695 11.5286 8.86193C11.6536 8.7369 11.8232 8.66667 12 8.66667C12.1768 8.66667 12.3464 8.7369 12.4714 8.86193C12.5964 8.98695 12.6667 9.15652 12.6667 9.33333V11.3333H14.6667C14.8435 11.3333 15.013 11.4036 15.1381 11.5286C15.2631 11.6536 15.3333 11.8232 15.3333 12C15.3333 12.1768 15.2631 12.3464 15.1381 12.4714C15.013 12.5964 14.8435 12.6667 14.6667 12.6667Z"
          fill="white" />
      </svg>
      Nuevo cobro
    </button>

    <p-splitButton [label]="exporting() ? 'Exportando...' : 'Exportar'" [model]="exportItems" [disabled]="exporting()"
      [buttonDisabled]="true" styleClass="sb-export-only">
      @if (exporting()) {
      <ng-template pTemplate="icon">
        <i class="pi pi-spin pi-spinner"></i>
      </ng-template>
      }
    </p-splitButton>


    <button
      class="action-button h-[40px] flex items-center gap-2 bg-indigo-500 text-white px-4 rounded-lg shadow hover:bg-indigo-600"
      (click)="openFilterDialog()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.66659 7.16716H6.49041C6.85038 8.49159 8.21584 9.27345 9.54027 8.91349C10.3909 8.68229 11.0554 8.0178 11.2866 7.16716H19.3318C19.7 7.16716 19.9984 6.86872 19.9984 6.50057C19.9984 6.13242 19.7 5.83398 19.3318 5.83398H11.2866C10.9266 4.50951 9.56118 3.72765 8.23674 4.08762C7.38611 4.31881 6.72161 4.98331 6.49041 5.83395H4.66659C4.29844 5.83395 4 6.13239 4 6.50054C4 6.86869 4.29844 7.16716 4.66659 7.16716Z"
          fill="white" />
        <path
          d="M19.3318 11.3334H17.508C17.1487 10.0092 15.784 9.22686 14.4598 9.58608C13.6085 9.81703 12.9434 10.4821 12.7125 11.3334H4.66659C4.29844 11.3334 4 11.6318 4 12C4 12.3682 4.29844 12.6666 4.66659 12.6666H12.7125C13.0717 13.9908 14.4364 14.7731 15.7607 14.4139C16.612 14.183 17.277 13.5179 17.508 12.6666H19.3318C19.7 12.6666 19.9984 12.3682 19.9984 12C19.9984 11.6318 19.7 11.3334 19.3318 11.3334Z"
          fill="white" />
        <path
          d="M19.3318 16.8329H11.2866C10.9266 15.5084 9.56118 14.7266 8.23674 15.0865C7.38611 15.3177 6.72161 15.9822 6.49041 16.8329H4.66659C4.29844 16.8329 4 17.1313 4 17.4995C4 17.8676 4.29844 18.1661 4.66659 18.1661H6.49041C6.85038 19.4905 8.21584 20.2723 9.54027 19.9124C10.3909 19.6812 11.0554 19.0167 11.2866 18.1661H19.3318C19.7 18.1661 19.9984 17.8676 19.9984 17.4995C19.9984 17.1313 19.7 16.8329 19.3318 16.8329Z"
          fill="white" />
      </svg>

      Filtrar
    </button>

  </div>
</section>

<!-- pseudo tabla -->
<!-- header -->
<section
  class="h-[48px] grid grid-cols-5 bg-white rounded-lg justify-items-center py-2 text-neutral-600 font-semibold text-sm mb-6">
  <div class="celda-centrada border-r">
    <div class="flex items-center cursor-pointer" (click)="sort('id')">
      ID de cobro
      <!-- <div class="ml-2 flex flex-col gap-[2px] ">
        <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg"
          [class.opacity-20]="isSortedBy('id', sortDirectionEnum.DESC)" />
        <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg"
          [class.opacity-20]="isSortedBy('id', sortDirectionEnum.ASC)" />
      </div> -->
    </div>
  </div>
  <div class="celda-centrada border-r">
    <div class="flex items-center cursor-pointer" (click)="sort('date')">
      Fecha/Hora
      <div class="ml-2 flex flex-col gap-[2px]">
        <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg"
          [class.opacity-20]="isSortedBy('date', sortDirectionEnum.DESC)" />
        <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg"
          [class.opacity-20]="isSortedBy('date', sortDirectionEnum.ASC)" />
      </div>
    </div>
  </div>
  <div class="celda-centrada border-r">
    <div class="flex items-center cursor-pointer" (click)="sort('amount')">
      Monto
      <div class="ml-2 flex flex-col gap-[2px]">
        <img class="w-[9px]" src="../../../assets/img/table/ic-sort-asc.svg"
          [class.opacity-20]="isSortedBy('amount', sortDirectionEnum.DESC)" />
        <img class="w-[9px]" src="../../../assets/img/table/ic-sort-desc.svg"
          [class.opacity-20]="isSortedBy('amount', sortDirectionEnum.ASC)" />
      </div>
    </div>
  </div>
  <div class="celda-centrada border-r">
    <div class="flex items-center cursor-pointer" (click)="sort('type')">
      Tipo de cobro
    </div>
  </div>
  <div class="celda-centrada">
    <div class="flex items-center cursor-pointer" (click)="sort('status')">
      Estado
    </div>
  </div>
</section>

@if (loading()) {
<p-dataView #dv [value]="loadingSkeletonRows" [rows]="5" [paginator]="false">
  <ng-template #list let-skeletonLoading>
    @for (item of skeletonLoading; track $index) {
    <div class="h-[48px] borde-2 bg-white py-3 text-center items-center shadow-1 mb-2 flex rounded-lg">
      <span class="h-5 px-3 flex-1 border-r">
        <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
      </span>
      <span class="h-5 px-3 flex-1 border-r">
        <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
      </span>
      <span class="h-5 px-3 flex-1 border-r">
        <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
      </span>
      <span class="h-5 px-3 flex-1 border-r">
        <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
      </span>
      <span class="h-5 px-3 flex-1 ">
        <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
      </span>
    </div>
    }
  </ng-template>
</p-dataView>
} @else {
@if (filteredCharges().length === 0) {
<div class="empty-state">
  <p>No tienes cobros generados</p>
  <!-- <app-button variant="primary" (click)="openNewChargeDialog()">
        Nuevo cobro
      </app-button> -->
</div>
} @else {
<p-dataView #dv [value]="filteredCharges()" [rows]="10" [paginator]="true">
  <ng-template #list let-charges>
    <div class="flex flex-col gap-2 mb-6">
      @for (charge of charges; track charge.id) {
      <section
        class="h-[48px] grid grid-cols-5 bg-white rounded-lg justify-items-center py-2 text-neutral-600 text-sm hover:bg-neutral-100">
        <div class="celda-centrada border-r">
          {{charge.order_number}}
        </div>
        <div class="celda-centrada border-r">
          {{ charge.date | date:'dd/MM/yyyy HH:mm' }}
        </div>
        <div class="celda-centrada border-r">
          {{ charge.amount | currencyClp }}
        </div>
        <div class="celda-centrada border-r">
          {{charge.type}}
        </div>
        <div class="celda-centrada !justify-between pr-4">
          <app-badge class="flex-1 flex justify-center" [variant]="getVariant(charge)">
            {{ charge.status }}
          </app-badge>

          @if(charge.status != ChargeStatusEnum.ANULADO) {
          <p-splitbutton label="" [model]="charge.menuItems" styleClass="sb-options-only">
            <ng-template pTemplate="content"></ng-template>
            <ng-template pTemplate="dropdownicon">
              <img alt="3 puntos" src="../../../assets/img/charges/ic-menu-dots.svg" class="w-6" />
            </ng-template>
          </p-splitbutton>
          } @else {
          <!-- para no descuadrar la vista -->
          <span class="w-6"></span>
          }
        </div>
      </section>
      }
    </div>
  </ng-template>
</p-dataView>
}
}

@if (showNewChargeDialog()) {
<app-new-charge-dialog [chargeData]="selectedCharge()" (close)="closeNewChargeDialog()"
  (closeBlank)="closeNewChargeDialogBlank()" (chargeCreated)="onChargeCreated()">
</app-new-charge-dialog>
}

@if (showStatusDialog()) {
<app-status-dialog [type]="showStatusDialog()!" (close)="closeStatusDialog()">
</app-status-dialog>
}

@if (showDetailChargeDialog()) {
<app-charge-detail-dialog [charge]="selectedCharge()" (close)="closeDetailDialog()">
</app-charge-detail-dialog>
}

@if (showConfirmChargeDialog()) {
<app-confirm-charge-dialog [items]="selectedCharge()?.items || []" [total]="selectedCharge()?.amount || 0"
  [paymentLinkUrl]="selectedCharge()?.payment_link_url" (close)="closeConfirmChargeDialog()">
</app-confirm-charge-dialog>
}

<!-- Drawer de filtros -->
<p-drawer [(visible)]="visible" position="right" [showCloseIcon]="false" [modal]="true"
  styleClass="filters-drawer w-[380px] max-w-[90vw]">

  <!-- Header custom -->
  <ng-template pTemplate="header">
    <div class="flex flex-col gap-2 w-full mt-3">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center gap-2">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.66659 7.16716H6.49041C6.85038 8.49159 8.21584 9.27345 9.54027 8.91349C10.3909 8.68229 11.0554 8.0178 11.2866 7.16716H19.3318C19.7 7.16716 19.9984 6.86872 19.9984 6.50057C19.9984 6.13242 19.7 5.83398 19.3318 5.83398H11.2866C10.9266 4.50951 9.56118 3.72765 8.23674 4.08762C7.38611 4.31881 6.72161 4.98331 6.49041 5.83395H4.66659C4.29844 5.83395 4 6.13239 4 6.50054C4 6.86869 4.29844 7.16716 4.66659 7.16716Z"
              fill="#535353" />
            <path
              d="M19.3318 11.3334H17.508C17.1487 10.0092 15.784 9.22686 14.4598 9.58608C13.6085 9.81703 12.9434 10.4821 12.7125 11.3334H4.66659C4.29844 11.3334 4 11.6318 4 12C4 12.3682 4.29844 12.6666 4.66659 12.6666H12.7125C13.0717 13.9908 14.4364 14.7731 15.7607 14.4139C16.612 14.183 17.277 13.5179 17.508 12.6666H19.3318C19.7 12.6666 19.9984 12.3682 19.9984 12C19.9984 11.6318 19.7 11.3334 19.3318 11.3334Z"
              fill="#535353" />
            <path
              d="M19.3318 16.8329H11.2866C10.9266 15.5084 9.56118 14.7266 8.23674 15.0865C7.38611 15.3177 6.72161 15.9822 6.49041 16.8329H4.66659C4.29844 16.8329 4 17.1313 4 17.4995C4 17.8676 4.29844 18.1661 4.66659 18.1661H6.49041C6.85038 19.4905 8.21584 20.2723 9.54027 19.9124C10.3909 19.6812 11.0554 19.0167 11.2866 18.1661H19.3318C19.7 18.1661 19.9984 17.8676 19.9984 17.4995C19.9984 17.1313 19.7 16.8329 19.3318 16.8329Z"
              fill="#535353" />
          </svg>
          <span class="filtros-title">Filtros</span>
        </div>
        <!-- botón de cerrar personalizado -->
        <button class="p-0 border-0 bg-transparent rounded p-1" (click)="visible=false">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.6602 11.9699L19.4566 7.16859C19.768 6.81465 19.9329 6.35542 19.9179 5.88423C19.9029 5.41305 19.7089 4.96527 19.3756 4.63192C19.0422 4.29857 18.5945 4.10467 18.1233 4.08962C17.6521 4.07458 17.1929 4.23952 16.8389 4.55093L12.0376 9.34729L7.22765 4.53609C7.05536 4.36381 6.85083 4.22714 6.62573 4.1339C6.40063 4.04067 6.15937 3.99268 5.91573 3.99268C5.67208 3.99268 5.43082 4.04067 5.20572 4.1339C4.98062 4.22714 4.77609 4.36381 4.60381 4.53609C4.43152 4.70837 4.29486 4.91291 4.20162 5.13801C4.10838 5.36311 4.06039 5.60437 4.06039 5.84801C4.06039 6.09166 4.10838 6.33292 4.20162 6.55802C4.29486 6.78312 4.43152 6.98765 4.60381 7.15993L9.41501 11.9699L4.61864 16.77C4.43054 16.9381 4.27872 17.1429 4.17247 17.3717C4.06622 17.6006 4.00778 17.8487 4.00073 18.1009C3.99367 18.3531 4.03814 18.6041 4.13142 18.8385C4.2247 19.0729 4.36484 19.2859 4.54324 19.4643C4.72165 19.6427 4.93458 19.7828 5.169 19.8761C5.40343 19.9694 5.65442 20.0138 5.90663 20.0068C6.15883 19.9997 6.40695 19.9413 6.63579 19.835C6.86463 19.7288 7.06939 19.577 7.23754 19.3889L12.0376 14.5925L16.8327 19.3889C17.1807 19.7368 17.6526 19.9323 18.1447 19.9323C18.6367 19.9323 19.1086 19.7368 19.4566 19.3889C19.8045 19.0409 20 18.569 20 18.0769C20 17.5849 19.8045 17.113 19.4566 16.765L14.6602 11.9699Z"
              fill="#737CFD" />
          </svg>
        </button>
      </div>
      <small class="filtros-subtitle">Los cambios se aplican y guardan automáticamente</small>
    </div>
  </ng-template>
  <div>

    @if (form) {
    <form [formGroup]="form">
      <p-accordion [value]="['0', '1', '2']" [multiple]="true">
        <!-- Rango de fechas -->
        <p-accordion-panel value="0">
          <p-accordion-header class="pt-0 !important">Rango de fechas</p-accordion-header>
          <p-accordion-content>
            <div>
              <div class="flex items-center pt-2">
                <p-radioButton inputId="all" value="all" formControlName="dateRange"></p-radioButton>
                <label for="all" class="ml-2 cursor-pointer filter-label">Todo</label>
              </div>
              <div class="flex items-center pt-2">
                <p-radioButton inputId="today" value="today" formControlName="dateRange"></p-radioButton>
                <label for="today" class="ml-2 cursor-pointer filter-label ">Hoy</label>
              </div>
              <div class="flex items-center pt-2">
                <p-radioButton inputId="yesterday" value="yesterday" formControlName="dateRange"></p-radioButton>
                <label for="yesterday" class="ml-2 cursor-pointer filter-label">Ayer</label>
              </div>
              <div class="flex items-center pt-2">
                <p-radioButton inputId="last7days" value="last7days" formControlName="dateRange"></p-radioButton>
                <label for="last7days" class="ml-2 cursor-pointer filter-label">Últimos 7 días</label>
              </div>
              <div class="flex items-center pt-2">
                <p-radioButton inputId="last30days" value="last30days" formControlName="dateRange"></p-radioButton>
                <label for="last30days" class="ml-2 cursor-pointer filter-label">Últimos 30 días</label>
              </div>
              <div class="flex items-center pt-2">
                <p-radioButton inputId="custom" value="custom" formControlName="dateRange"></p-radioButton>
                <label for="custom" class="ml-2 cursor-pointer filter-label">Personalizado</label>
              </div>
              @if (form.get('dateRange')?.value === 'custom') {
              <div class="mt-4 space-y-3 pl-6">
                <div>
                  <label class="block mb-1 filter-label pt-2">Desde</label>
                  <p-datePicker formControlName="from" [showIcon]="true" dateFormat="dd/mm/yy"
                    placeholder="Seleccionar fecha"></p-datePicker>
                </div>
                <div>
                  <label class="block mb-1 filter-label pt-2">Hasta</label>
                  <p-datePicker formControlName="to" [showIcon]="true" dateFormat="dd/mm/yy"
                    placeholder="Seleccionar fecha"></p-datePicker>
                </div>
              </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <!-- Tipo de cobro -->
        <p-accordion-panel value="1">
          <p-accordion-header>Tipo de cobro</p-accordion-header>
          <p-accordion-content>
            <div class="space-y-0">
              <div class="flex items-center pt-2">
                <p-checkbox inputId="allTypes" [binary]="true" [ngModel]="areAllTypesSelected()"
                  [ngModelOptions]="{standalone: true}" (ngModelChange)="toggleAllTypes($event)"></p-checkbox>
                <label for="allTypes" class="ml-2 cursor-pointer filter-label">Todos</label>
              </div>
              @for (type of availableTypes; track type) {
              <div class="flex items-center pt-2">
                <p-checkbox [inputId]="'type-' + type" [binary]="true" [ngModel]="isTypeSelected(type)"
                  [ngModelOptions]="{standalone: true}" (ngModelChange)="onTypeToggle(type, $event)"></p-checkbox>
                <label [for]="'type-' + type" class="ml-2 cursor-pointer filter-label">{{ type }}</label>
              </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <!-- Estado -->
        <p-accordion-panel value="2">
          <p-accordion-header>Estado</p-accordion-header>
          <p-accordion-content>
            <div>
              <div class="flex items-center pt-2">
                <p-checkbox inputId="allStatuses" [binary]="true" [ngModel]="areAllStatusesSelected()"
                  [ngModelOptions]="{standalone: true}" (ngModelChange)="toggleAllStatuses($event)"></p-checkbox>
                <label for="allStatuses" class="ml-2 cursor-pointer filter-label">Todos</label>
              </div>
              @for (status of statusOptions; track status) {
              <div class="flex items-center pt-2">
                <p-checkbox [inputId]="'status-' + status" [binary]="true" [ngModel]="isStatusSelected(status)"
                  [ngModelOptions]="{standalone: true}" (ngModelChange)="onStatusToggle(status, $event)"></p-checkbox>
                <label [for]="'status-' + status" class="ml-2 cursor-pointer filter-label">{{ status }}</label>
              </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </form>
    }

    <button (click)="clearFilters()"
      class="w-full flex items-center justify-center gap-2 p-3 mt-7 bg-transparent border-0"
      style="font-family: Inter; font-weight: 600; font-size: 16px; line-height: 100%; text-align: center;">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.82112 8.94655L12.1358 5.6439C12.7646 5.01311 13.6034 4.66504 14.4962 4.66504C15.3891 4.66504 16.2273 5.01311 16.8574 5.64523L19.0271 7.82233C20.3201 9.11992 20.3201 11.2317 19.0271 12.5299L15.7118 15.8579L8.82112 8.94655ZM19.3332 18.0017H13.5767L14.771 16.8028L7.87627 9.88807L4.96969 12.784C3.67677 14.0816 3.67677 16.1933 4.96969 17.4909L6.02523 18.5505C6.522 19.0492 7.21014 19.3353 7.91494 19.3353H19.3332C19.7019 19.3353 20 19.0365 20 18.6685C20 18.3004 19.7019 18.0017 19.3332 18.0017Z"
          fill="#737CFD" />
      </svg>
      Limpiar filtros
    </button>
  </div>
</p-drawer>